import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaIdCard,
    FaMapMarkerAlt,
    FaBaby,
    FaNotesMedical,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import ResultsWrapper from './Results';
import IdentificationWrapper from './Identification';
import OccurenceLocationWrapper from './OccurenceLocation';
import FetalDeathWrapper from './FetalDeath';
import CausesCondictionsWrapper from './CausesCondictions';

const menus = [
    {
        title: 'Resultados',
        path: '/governanceroom/dashboardvitalstatistics/mortality/results',
        icon: <FaChartBar style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Identificação',
        path: '/governanceroom/dashboardvitalstatistics/mortality/id',
        icon: <FaIdCard style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Local de Ocorrência',
        path: '/governanceroom/dashboardvitalstatistics/mortality/occurrence',
        icon: <FaMapMarkerAlt style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Óbito Fetal',
        path: '/governanceroom/dashboardvitalstatistics/mortality/fetal-death',
        icon: <FaBaby style={{ marginRight: '5px' }} /> 
    },
    {
        title: 'Condições e Causas',
        path: '/governanceroom/dashboardvitalstatistics/mortality/conditions-causes',
        icon: <FaNotesMedical style={{ marginRight: '5px' }} /> 
    },
];

const titleMap = {
    '/governanceroom/dashboardvitalstatistics/mortality/results': 'Resultados Gerais do SIM',
    '/governanceroom/dashboardvitalstatistics/mortality/id': 'Resultados Gerais de Identificação do SIM',
    '/governanceroom/dashboardvitalstatistics/mortality/occurrence': 'Resultados Gerais de Local de Ocorrência do SIM',
    '/governanceroom/dashboardvitalstatistics/mortality/fetal-death': 'Resultados Gerais de Óbito Fetal do SIM',
    '/governanceroom/dashboardvitalstatistics/mortality/conditions-causes': 'Resultados Gerais de Condições e Causas do SIM'
};

const Mortality = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardvitalstatistics');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="results" replace />}
                        />
                        <Route
                            path="results"
                            element={<ResultsWrapper />}
                        />
                        <Route
                            path="id"
                            element={<IdentificationWrapper />}
                        />
                        <Route
                            path="occurrence"
                            element={<OccurenceLocationWrapper />}
                        />
                        <Route
                            path="fetal-death"
                            element={<FetalDeathWrapper />}
                        />
                        <Route
                            path="conditions-causes"
                            element={<CausesCondictionsWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Mortality;
